import React, { Component, Fragment } from "react";
// import Media from "react-media";
// import moment from "moment-timezone";
import { Link } from "react-router-dom";
// import { SCREEN_WIDTH } from "../../App.js";
import { translate } from "react-i18next";
import brandLogo from "../../images/brand-logo-dark.png";

class Benefits extends Component {
  getEventLink = (event) => {
    return {
      pathname: "/benefit/" + event.id,
      state: {
        center: JSON.stringify(this.props.center),
        event: JSON.stringify(event),
      },
    };
  };

  renderEvent = (event, index) => {
    const { t } = this.props;

    return (
      <div
        className="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-6 card-panel-benefits"
        key={index}
      >
        <div className="card-panel panel panel-default card box-radius">
          {event.logo ? (
            <div
              className="panel-heading card-panel-heading"
              style={{
                backgroundImage:
                  "url('https://img.iosoffices.com/img/beneficios/beneficios_logos_empresa/" +
                  event.logo +
                  "')",
              }}
            ></div>
          ) : (
            <div
              className="panel-heading card-panel-heading"
              style={{ backgroundImage: "url('" + brandLogo + "')" }}
            ></div>
          )}
          <div className="card-panel-body item">
            <div className="panel-body-title">
              <h4 className="ioscentro inline">{event.name.toUpperCase()}</h4>
              <div className="contenedor-inline contenedor-event">
                {event.tags.map((tag, index) => (
                  <h4 className="label label-accent" key={index}>
                    {tag.name}
                  </h4>
                ))}
              </div>
              <h4 className="iossala">
                {event.group_name === "Tarifa Preferencial"
                  ? event.group_name
                  : event.discount + "% DE DESCUENTO"}
              </h4>
            </div>
            <div className="panel-body-description">
              <div className="panel-description-text">
                {event.discount_terms.slice(0, 150)}
                {event.discount_terms.length > 150 ? "..." : null}
              </div>
              <div className="contenedor-flexbox contenedor-event">
                {event.cities.length < 4
                  ? event.cities.map((city, index) => (
                      <h4 className="label label-primary" key={index}>
                        {city.name}
                      </h4>
                    ))
                  : event.cities.map((city, index) =>
                      index < 10 ? (
                        <h4 className="label label-primary" key={index}>
                          {city.name}
                          {Number.isInteger((index + 1) / 2) ? <br></br> : null}
                        </h4>
                      ) : null
                    )}
              </div>
            </div>
            <div className="panel-body-bottom">
              <div className="panel-body form-group">
                <Link to={this.getEventLink(event)}>
                  <button
                    className="btn btn-block btn-primary btn-singup btn_create"
                    type="button"
                  >
                    {t("guest.benefits.btn_info")}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // No se porque nombre este metodo asi
  render() {
    const events = this.props.events;
    return (
      <div className="list-card-benefits">
        <div className="list-card-panel-seccion">
          <Events events={events.new} title="Beneficios nuevos del mes">
            {this.renderEvent}
          </Events>
          <Events events={events.old} title="Todos los Beneficios">
            {this.renderEvent}
          </Events>
        </div>
      </div>
    );
  }
}

const Events = ({ title = "", events = [], children }) => {
  return (
    <Fragment>
      <h4>{events.length ? title : null}</h4>
      <div className="content-card-panel-seccion grid-2">
        {events.map((event, index) => children(event, index + 1))}
      </div>
    </Fragment>
  );
};

export default translate("common")(Benefits);



// WEBPACK FOOTER //
// ./src/dashboard/benefits/Benefits.js